'use strict';

import notices from './notices/index';
import purchases from './purchases/index';
import contracts from './contracts/index';

const GroupCommercialStoreModule = {
    namespaced: true,

    modules: {
        notices,
        purchases,
        contracts
    }
};

export default GroupCommercialStoreModule;
